import { MedicalConditionEnum } from '../../lib/types/enums/enrollment/medical-condition-enum'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function checkMedicalLevel(input: { text: string }) {
  const { text } = input
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.medicalTerms.checkMedicalLevel.url, null), { text })
    )
    .get<{ result: MedicalConditionEnum }>()
}
